import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const paymentSlice = createSlice({
  name: "payment",
  initialState: {
    payments: [],
    paymentDetails: {},
    refetch: false,
  },
  reducers: {
    setPaymentDetails: (state, action) => {
      state.paymentDetails = action.payload;
    },
    setPayments: (state, action) => {
      state.payments = action.payload;
    },
    refetch: (state, action) => {
      state.refetch = action.payload;
    },
  },
});

export const { setPaymentDetails, setPayments, refetch } = paymentSlice.actions;

export const getPayments = (setLoading) => async (dispatch) => {
  try {
    const url = `${BASE_URL}/payment/all-payments/v1`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("sgtoken"),
      },
    });
    dispatch(setPayments(data.data));
    setLoading(false);
  } catch (error) {
    toast.error(error.response.data.message, {
      position: "top-center",
      autoClose: 3000,
    });
    setLoading(false);
  }
};

export const getpaymentDetails = (id, setLoading) => async (dispatch) => {
  try {
    const url = `${BASE_URL}/payment/payment-details/${id}/v1`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("sgtoken"),
      },
    });
    dispatch(setPaymentDetails(data.data));
    setLoading(false);
  } catch (error) {
    toast.error(error.response.data.message, {
      position: "top-center",
      autoClose: 3000,
    });
    setLoading(false);
  }
};

export const deletePayment = (id) => async (dispatch) => {
  try {
    dispatch(refetch(false));
    const url = `${BASE_URL}/payment/delete-payment-history/${id}/v1`;

    const { data } = await axios.delete(url, {
      headers: {
        Authorization: localStorage.getItem("sgtoken"),
      },
    });
    toast.success("Deleted Successfully", {
      position: "top-center",
      autoClose: 3000,
    });
    dispatch(refetch(true));
  } catch (error) {
    toast.error(error.response.data.message, {
      position: "top-center",
      autoClose: 3000,
    });
  }
};
export default paymentSlice.reducer;
